module.exports = __webpack_public_path__ + "static/media/maybankheart-logo-black.22218678.svg";